export const homeMenu = {
    intro: {
        id: 'intro',
        text: 'Intro',
        path: '#intro',
        icon: 'Vrpano',
        subMenu: null,
    },
    bootstrap: {
        id: 'bootstrap',
        text: 'Bootstrap Components',
        path: '#bootstrap',
        icon: 'BootstrapFill',
        subMenu: null,
    },
    storybook: {
        id: 'storybook',
        text: 'Storybook',
        path: '#storybook',
        icon: 'CustomStorybook',
        subMenu: null,
    },
    formik: {
        id: 'formik',
        text: 'Formik',
        path: '#formik',
        icon: 'CheckBox',
        subMenu: null,
    },
    apex: {
        id: 'apex',
        text: 'Apex Charts',
        path: '#apex',
        icon: 'AreaChart',
        subMenu: null,
    },
};

export const dashboardMenu = {
    dashboard: {
        id: 'dashboard',
        text: 'Dashboard',
        path: '/',
        icon: 'Dashboard',
        subMenu: null,
    },
};

export const demoPages = {
    pages: {
        id: 'pages',
        text: 'Companion Options',
        icon: 'Extension',
    },
    publishPost: {
        id: 'publishPost',
        text: 'Publish',
        path: '/publish-post',
        icon: 'Upload File',
    },
    schedulePost: {
        id: 'schedulePost',
        text: 'Schedule',
        path: '/schedule-post',
        icon: 'Calendar Today',
    },
    postHistory: {
        id: 'postHistory',
        text: 'Post History',
        path: '/post-history',
        icon: 'Access Time',
    },
    pricingTable: {
        id: 'pricingTable',
        text: 'Subscription Plans',
        path: '/subscription',
        icon: 'Local Offer',
    },
};
